<div class="infoviewer-table-container">
  @if (show !== false) {
  <uv-table class="infoviewer-table" #dt [columns]="cols" [value]="entries" [resizableColumns]="true"
    [selectionMode]="selectionMode" [selection]="selection" [scrollable]="true" [scrollHeight]="scrollHeight"
    [customSort]="true" (sortFunction)="doCustomSort($event)" [virtualScroll]="true"
    [virtualScrollItemSize]="VirtualScrollItemSize">
    <ng-template pTemplate="caption">
      <div (contextmenu)="cm.show($event)">
        <button pButton icon="fa fa-file-o" iconPos="left" label="Export" (click)="dt.exportCSV()"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr (contextmenu)="cm.show($event)">
        @for (col of cols; track col) {
        <th uvResizableColumn [uvSortableColumn]="col.field">
          {{col.header}}
          <uv-sortIcon [field]="col.field"></uv-sortIcon>
        </th>
        }
      </tr>
      <tr>
        @for (col of cols; track col) {
        <th class="if-table-cell" [ngStyle]="{'flex-grow': col.width}">
          <input #filter pInputText type="text" style="width: 100%;"
            (input)="dt.filter($event.target.value, col.field, 'contains')">
        </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [style]="TableRowStyle" [uvSelectableRow]="rowData"
        (contextmenu)="onBodyCmClick(rowData); bodycm.show($event);">
        @for (col of cols; track col) {
        <td [class]="cellClasses(col.field, rowData)" pTooltip="{{rowData[col.field]}}">
          <span class="uv-table-value">{{rowData[col.field]}}</span>
        </td>
        }
      </tr>
    </ng-template>
  </uv-table>
  }

  <p-contextMenu #cm [model]="cmItems" appendTo="body" [baseZIndex]="4000"></p-contextMenu>

  <p-contextMenu #bodycm [model]="bodyCmItems" appendTo="body" [baseZIndex]="4000"></p-contextMenu>

  <p-dialog [(visible)]="displaySelectColumnsDialog" class="infoset-column-selector" [resizable]="false"
    (onHide)="onSelectColumnsDialogHide()">

    <p-header>
      <span>Select Columns</span>
    </p-header>

    <p-listbox [options]="selectItems" [(ngModel)]="cols" multiple="multiple" checkbox="checkbox"
      (onChange)="onColumnSelectionChange($event)"></p-listbox>

    <p-footer>
      <button type="button" pButton icon="fa fa-times" (click)="closeSelectColumnsDialog()" label="Close"></button>
    </p-footer>

  </p-dialog>

</div>